export default __webpack_public_path__ + "static/media/7_1.45b43147.jpg";